import React, {Component} from 'react';
import LogoContainer from "./LogoContainer";
import NavBarContainer from "./NavBarContainer";
import NavBarSettingsContainer from "./HeaderSettingsContainer";
import HeaderLoginContainer from "./HeaderLoginContainer";
import './header.css';

class Header extends Component {
    render() {
        return (
            <>
                <nav className="navbar navbar-expand-lg navbar-dark bg-dark" role="navigation">
                    <div className="container">
                        <LogoContainer/>
                        <NavBarContainer/>
                        <ul className="nav navbar-nav flex-row justify-content-between ml-auto">
                            <NavBarSettingsContainer/>
                            <HeaderLoginContainer/>
                        </ul>
                    </div>
                </nav>
            </>
        )
    }
}

export default Header;